import { getEnvVar } from 'shared/src/utils/env'

export const CONTACT_URL = 'mailto:hello@shoprodeo.com'
export const CREATOR_APP_URL = getEnvVar('CREATOR_URL')
export const INSTAGRAM_URL = getEnvVar('INSTAGRAM_URL')
export const SHOPPER_URL = getEnvVar('SHOPPER_URL')
export const GO2APP_URL = getEnvVar('GO2APP_URL')
export const TIK_TOK_URL = getEnvVar('TIK_TOK_URL')
export const WAITLIST_URL =
  'https://apps.apple.com/us/app/shop-rodeo/id6471020533'
export const APP_WAITLIST_URL =
  'https://apps.apple.com/us/app/shop-rodeo/id6471020533'

export const isInternalUrl = (url: string) => url.startsWith(SHOPPER_URL)
